var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dib"},[_c('el-cascader',{attrs:{"options":_vm.options,"clearable":"","props":{ expandTrigger: 'hover' }},on:{"change":_vm.change},model:{value:(_vm.selected_1),callback:function ($$v) {_vm.selected_1=$$v},expression:"selected_1"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }